import './index.scss'
import './responsive.scss'

const Syllabus = () => {

    return (

        <div className="container programa">

            <section class="section--programa">
            <p class="about__programa">
            Programa Creative Coding 2022
            <br />
            <br />
            Objetivo: Iniciar el desarrollo del pensamiento computacional e introducir en los lenguajes y herramientas de la
            interacción humano-máquina poniendo especial énfasis en distintas prácticas creativas que enlazan los mundos de la
            ciencia con los mundos de las artes; el reino de las cosas y la materia con lo digital.
            Durante todo el curso se pondrá especial énfasis en el desarrollo del ‘human learning’, es decir: el desarrollo de la
            colaboración empática; la comunicación abierta del conocimiento abierto; la comunicación no verbal y los distintos modos
            de devenir en el mundo.
            <br />
            <br />
            Fundamentación: los escenarios de la vida cotidiana en la actualidad se encuentran entrelazados con los lenguajes de la
            interactividad tecno-electronica; este entrelazamiento encuentra en una (o varias) de sus capas al código de
            programación que ordena, distribuye y propone ciertos comportamientos a los actores (sean estos humanos o no-humanos).
            Este taller se propone adentrarse en el código a partir de prácticas propias del campo de la creatividad, es por ello
            que el camino se inicia con el actual lenguaje de programación destinado a las prácticas interactivas: JavaScript. A
            partir de allí, se sentarán las bases para iniciar un camino que comprenderá las interacciones humano-máquina (sin
            descuidar las interacciones interespecies); la incursión en la Investigación en la Experiencia de Usuarios (UX)
            focalizada en experiencias artísticas; el desarrollo de interfaces lúdicas.
            <br />
            <br />
            Metodología: En muchas ocasiones, se utilizarán metodologías propias del campo del diseño (se introducirán nociones de
            Design Thinking y diseño proyectual) pero en simultáneo y como eje central de esta propuesta se trabajará en un contexto
            de experimentación artística antiproyectual que permitirá dar cuenta de ciertas formas de producir ligadas a la
            discontinuidad, serialidad, retroprogresión, zonas de inquietudes íntimas y personales que muchas veces son esquivas a
            los esquemas de formalización pero encuentran espacio en los “entre”, la dispersión y/o el balbuceo.
            Es de resaltar que dentro de este espacio experimental en el que se tendrán siempre a mano las metodologías del campo
            del diseño, se introducirán, en una primera instancia, nociones comunes que definan un lenguaje compartido para una vez
            apropiado dar lugar al desarrollo de un estilo propio y puesta en práctica a partir de una posible búsqueda personal.
            <br />
            <br />
            Programa:
            <br />
            <br />
            Módulo 1: Nociones de programación: algoritmos, Scratch, JavaScript y Navegadores; metodologías proyectuales;
            introducción a la Interactividad.
            <br />
            <br />
            1 - Presentación: Metodologías. Herramientas. Instalación, puesta a punto y primeros pasos: algoritmos, Scratch e
            interactividad experimental.
            <br />
            <br />
            2 - Pensar la Interactividad en entornos digitales. Nociones de JavaScript 1 (Parte 1).
            <br />
            <br />
            3 - Nociones de JavaScript 2. Una vuelta de tuerca a la interactividad.
            <br />
            <br />
            4 - Primer momento: Hamlet en la era transmedia: narración e interacción en la era del código ubicuo.
            Segundo momento: pensar la pantalla como galería, cine o museo para el siglo XXI y una era post-humana.
            <br />
            <br />
            Módulo 2: Más allá de las pantallas. El antiproyecto, la no linealidad y la retroprogresión. Entrelazar mundos. UX
            research para un mundo transespecie.
            <br />
            <br />
            5 - Nociones comunes 2: Processing, Arduino, JavaScript. Una poética inestable de las conexiones electro-líquidas.
            <br />
            <br />
            6 - Desarrollo de interfaces lúdicas y dispositivos de interacción humano-máquina utilizando Processing, Arduino y
            JavaScript.
            <br />
            <br />
            7 - Desarrollo de interfaces lúdicas y dispositivos de interacción humano-máquina utilizando Processing, Arduino y
            JavaScript.
            <br />
            <br />
            8 - Nociones Comunes 3: Python, un lenguaje para el análisis de datos, el machine learning y la Inteligencia Artificial.
            <br />
            <br />
            9 - ¿Cómo entrenar modelos de Inteligencia Artificial para expandir la mente creativa? Construcción de datasets,
            entrenamiento de modelos, primeros resultados.
            <br />
            <br />
            Al finalizar el curso, quedará abierta la posibilidad de realizar una muestra a partir de la articulación de los deseos
            y resultados de les, las y los participantes.
            <br />
            <br />
            </p>
            </section>
            
            </div>

    )

}

export default Syllabus
